import { AdminClientReportHTML } from './AdminClientReportHTML';

export default AdminClientReportHTML;